import React, { useState, useEffect } from 'react'

import GlobalNotificationAlert from './globalNotificationAlert'
import GlobalNotificationModal from './globalNotificationModal'
import useGlobalNotification from 'hooks/useGlobalNotification'

const componentMap = {
  header: GlobalNotificationAlert,
  modal: GlobalNotificationModal,
} as const

const GlobalNotification = () => {
  const [open, setOpen] = useState(false)
  const { seenAt, updateAck, fetchGlobalNotification, notificationData } = useGlobalNotification()
  const { id, notificationType, message, heading, location, updatedAt } = notificationData

  const shouldOpen = (!!updatedAt) &&  (!seenAt || new Date(updatedAt) > new Date(seenAt))

  useEffect(() => {
    setOpen(shouldOpen)
  }, [shouldOpen])

  useEffect(() => {
    fetchGlobalNotification()
  }, [fetchGlobalNotification])

  if (!message || !heading || !location || !notificationType) return null

  const acknowledgeGlobalNotification = () => {
    setOpen(false)
    const newAck = { id, acknowledgedAt: new Date() } as const
    updateAck(newAck)
  }

  const strippedMessage = message.replace(/style=["'].*?["']/g, '')

// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly header: JSXElementConstructor<any>; readonly modal: JSXElementConstructor<Omit<Props, "classes"> & StyledComponentProps<"error" | "message" | "success" | "h1" | "icon" | "info" | ... 4 more ... | "justified"> & object>; }'.
  const NotificationComponent = componentMap[location]

  if (!NotificationComponent) return null

  return (
    <NotificationComponent
      heading={heading}
      message={strippedMessage}
      notificationType={notificationType}
      open={open}
      acknowledgeGlobalNotification={acknowledgeGlobalNotification}
    />
  )
}

export default GlobalNotification
